import { render } from "./CreateLook.vue?vue&type=template&id=4e4ac40f"
import script from "./CreateLook.vue?vue&type=script&lang=js"
export * from "./CreateLook.vue?vue&type=script&lang=js"
script.render = render

export default script